export const getDivvyAuthTokenExpirationDate = () => {
  const expirationDate = window.localStorage.getItem('token_expires_at')
  if (!expirationDate) return null
  return new Date(expirationDate).valueOf()
}
